import { combineReducers } from "redux";

import signInPageSlice from "./signInPageSlice";
import createPictureSlice from "./createPictureSlice";
import authSlice from "./authSlice";
import devicesSlice from "./devicesSlice";
import efficeTreeSlice from "./efficeTreeSlice";
import efficeCacheSlice from "./efficeCacheSlice";
import homeStartSlice from "./homeStartSlice";
import extraOptionsSlice from "./extraOptionsSlice";
import spaceSlice from "./spaceSlice";
import spaceMediaSlice from "./spaceMediaSlice";
import textSlice from "./textSlice";
import personalChannelSlice from "./channels/personalChannelSlice";
import socketSlice from "./channels/socketSlice";
import spaceChannelSlice from "./channels/spaceChannelSlice";
import generalSlice from "./generalSlice";
import peopleSlice from "./peopleSlice";
import myReadEfficesSlice from "./myReadEfficesSlice";
import joinSlice from "./joinSlice";
import spaceMyMediaSlice from "./spaceMyMediaSlice";
import mediaServerSlice from "./mediaServerSlice";

const appReducer = combineReducers({
  signInPage: signInPageSlice,
  createPicture: createPictureSlice,
  auth: authSlice,
  devices: devicesSlice,
  efficeTree: efficeTreeSlice,
  efficeCache: efficeCacheSlice,
  myReadEffices: myReadEfficesSlice,
  text: textSlice,
  people: peopleSlice,
  space: spaceSlice,
  spaceMedia: spaceMediaSlice,
  spaceMyMedia: spaceMyMediaSlice,
  mediaServer: mediaServerSlice,
  join: joinSlice,
  homeStart: homeStartSlice,
  extraOptions: extraOptionsSlice,
  socket: socketSlice,
  personalChannel: personalChannelSlice,
  spaceChannel: spaceChannelSlice,
  general: generalSlice,
});

const reducer = (state, action) => {
  if (action.type === "RESET_ALL_STATE") state = undefined;

  return appReducer(state, action);
};

export default reducer;
